import SwiperCore, {
  Scrollbar,
  Navigation,
  Autoplay,
  Pagination,
  Swiper,
} from 'swiper';
SwiperCore.use([Scrollbar, Navigation, Autoplay, Pagination]);

export const squadCarousel = () => {
  const container = document.querySelector('.squad__carousel');
  if (!container) return;
  const carousel = new Swiper('.squad__carousel', {
    slidesPerView: 3.5,
    spaceBetween: 20,
    autoplay: {
      delay: 0,
      waitForTransition: false,
    },
    centeredSlides: true,
    loop: true,
    autoHeight: true,
    speed: 3000,
    breakpoints: {
      // when window width is >= 640px
      640: {
        slidesPerView: 4.5,
      },
      1240: {
        slidesPerView: 6.5,
      },
    },
  });
};
